var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.instrument === 'cloudpayments')?_c('cloudpayment-form',{ref:"cloudpayments",attrs:{"payment-config":_vm.config.widget}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }